import { decodeHexResponse } from '../_common/common.utils';
import LeaveRestrictionTypes from './leaveRestriction.types';

const INITIAL_STATE = {
	loading: false,
	error: null,
	data: [],
	createLoading: false,
	createError: null,
	updateLoading: false,
	updateError: null,
	deleteLoading: false,
	deleteError: null,
};

export const leaveRestrictionReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case LeaveRestrictionTypes.FETCH_LEAVE_RESTRICTIONS_START:
			return {
				...state,
				loading: true,
				error: null,
			};
		case LeaveRestrictionTypes.FETCH_LEAVE_RESTRICTIONS_SUCCESS:
			return {
				...state,
				loading: false,
				data: (() => {
					const decoded = decodeHexResponse(
						action.payload,
						LeaveRestrictionTypes.FETCH_LEAVE_RESTRICTIONS_KEY,
					);
					const list = Array.isArray(decoded) ? decoded : decoded?.result;
					return Array.isArray(list) ? list : [];
				})(),
			};
		case LeaveRestrictionTypes.FETCH_LEAVE_RESTRICTIONS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case LeaveRestrictionTypes.CREATE_LEAVE_RESTRICTION_START:
			return {
				...state,
				createLoading: true,
				createError: null,
			};
		case LeaveRestrictionTypes.CREATE_LEAVE_RESTRICTION_SUCCESS:
			return {
				...state,
				createLoading: false,
				data: (() => {
					const decoded = decodeHexResponse(
						action.payload,
						LeaveRestrictionTypes.CREATE_LEAVE_RESTRICTION_KEY,
					);
					const list = Array.isArray(decoded) ? decoded : decoded?.result;
					return Array.isArray(list) ? list : [];
				})(),
			};
		case LeaveRestrictionTypes.CREATE_LEAVE_RESTRICTION_FAILURE:
			return {
				...state,
				createLoading: false,
				createError: action.payload,
			};
		case LeaveRestrictionTypes.UPDATE_LEAVE_RESTRICTION_START:
			return {
				...state,
				updateLoading: true,
				updateError: null,
			};
		case LeaveRestrictionTypes.UPDATE_LEAVE_RESTRICTION_SUCCESS:
			return {
				...state,
				updateLoading: false,
				data: (() => {
					const decoded = decodeHexResponse(
						action.payload,
						LeaveRestrictionTypes.UPDATE_LEAVE_RESTRICTION_KEY,
					);
					const list = Array.isArray(decoded) ? decoded : decoded?.result;
					return Array.isArray(list) ? list : [];
				})(),
			};
		case LeaveRestrictionTypes.UPDATE_LEAVE_RESTRICTION_FAILURE:
			return {
				...state,
				updateLoading: false,
				updateError: action.payload,
			};
		case LeaveRestrictionTypes.DELETE_LEAVE_RESTRICTION_START:
			return {
				...state,
				deleteLoading: true,
				deleteError: null,
			};
		case LeaveRestrictionTypes.DELETE_LEAVE_RESTRICTION_SUCCESS:
			return {
				...state,
				deleteLoading: false,
				// data: (Array.isArray(state.data) ? state.data : []).filter(
				// 	(item: any) => item.restrictLeaveID !== action.payload,
				// ),
				data: (() => {
					const decoded = decodeHexResponse(action.payload, 'deleteLeaveRestrictionKey');
					const list = decoded.filter((item: any) => item.restrictLeaveID !== decoded);
					return Array.isArray(list) ? list : [];
				})(),
			};
		case LeaveRestrictionTypes.DELETE_LEAVE_RESTRICTION_FAILURE:
			return {
				...state,
				deleteLoading: false,
				deleteError: action.payload,
			};
		case LeaveRestrictionTypes.UNPUBLISH_LEAVE_RESTRICTION_START:
			return {
				...state,
				updateLoading: true,
				updateError: null,
			};
		case LeaveRestrictionTypes.UNPUBLISH_LEAVE_RESTRICTION_SUCCESS:
			return {
				...state,
				updateLoading: false,
				data: (() => {
					const decoded = decodeHexResponse(
						action.payload,
						'unpublishLeaveRestrictionKey',
					);
					const list = decoded.map((item: any) =>
						item.restrictLeaveID === decoded ? { ...item, isPublish: 0 } : item,
					);
					return Array.isArray(list) ? list : [];
				})(),
				// data: state.data.map((item: any) =>
				// 	item.restrictLeaveID === action.payload ? { ...item, isPublish: 0 } : item,
				// ),
			};
		case LeaveRestrictionTypes.UNPUBLISH_LEAVE_RESTRICTION_FAILURE:
			return {
				...state,
				updateLoading: false,
				updateError: action.payload,
			};
		case LeaveRestrictionTypes.PUBLISH_LEAVE_RESTRICTION_START:
			return {
				...state,
				updateLoading: true,
				updateError: null,
			};
		case LeaveRestrictionTypes.PUBLISH_LEAVE_RESTRICTION_SUCCESS:
			return {
				...state,
				updateLoading: false,
				data: state.data.map((item: any) =>
					item.restrictLeaveID === action.payload ? { ...item, isPublish: 1 } : item,
				),
			};
		case LeaveRestrictionTypes.PUBLISH_LEAVE_RESTRICTION_FAILURE:
			return {
				...state,
				updateLoading: false,
				updateError: action.payload,
			};
		default:
			return state;
	}
};
